import { observable } from 'mobx';

const DATA_DASHBOARD = observable({
    DATA: "",
    PLATFORM_ID: 0,
    GROUP_ID: 0,
})

export { DATA_DASHBOARD }